import type { ProviderInfo } from '../types/foundObject';

export type PlaceStorageMode = 'combined' | 'split';

export function resolvePlaceStorageMode(
  providerInfo?: Pick<ProviderInfo, 'provider_type'> | null
): PlaceStorageMode {
  const mode = providerInfo?.provider_type?.place_storage_mode;
  return mode === 'split' ? 'split' : 'combined';
}

export function isSplitPlaceStorageMode(
  providerInfo?: Pick<ProviderInfo, 'provider_type'> | null
): boolean {
  return resolvePlaceStorageMode(providerInfo) === 'split';
}
